/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateCategoryResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListCategoriesResponseFromDiscriminatorValue, serializeCreateCategoryRequest, serializeCreateCategoryResponse, type CreateCategoryRequest, type CreateCategoryResponse, type ErrorResponse, type InternalErrorResponse, type ListCategoriesResponse } from '../../models/index.js';
// @ts-ignore
import { EmptyRequestBuilderRequestsMetadata, type EmptyRequestBuilder } from './empty/index.js';
// @ts-ignore
import { type WithCategoryItemRequestBuilder, WithCategoryItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { ReorderRequestBuilderRequestsMetadata, type ReorderRequestBuilder } from './reorder/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/categories
 */
export interface CategoriesRequestBuilder extends BaseRequestBuilder<CategoriesRequestBuilder> {
    /**
     * The empty property
     */
    get empty(): EmptyRequestBuilder;
    /**
     * The reorder property
     */
    get reorder(): ReorderRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.categories.item collection
     * @param category Unique identifier of the item
     * @returns {WithCategoryItemRequestBuilder}
     */
     byCategory(category: string) : WithCategoryItemRequestBuilder;
    /**
     * List all categories and subcategories for an organization
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListCategoriesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListCategoriesResponse | undefined>;
    /**
     * Creates a category on the caller's organization. The path is normalized (leading '/' added, trailing '/' stripped), nested paths are supported without the parent existing first, and creating a category that already exists is a no-op rather than a duplicate or an error.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateCategoryResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateCategoryRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateCategoryResponse | undefined>;
    /**
     * List all categories and subcategories for an organization
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Creates a category on the caller's organization. The path is normalized (leading '/' added, trailing '/' stripped), nested paths are supported without the parent existing first, and creating a category that already exists is a no-op rather than a duplicate or an error.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateCategoryRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CategoriesRequestBuilderUriTemplate = "{+baseurl}/api/categories";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CategoriesRequestBuilderNavigationMetadata: Record<Exclude<keyof CategoriesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCategory: {
        requestsMetadata: WithCategoryItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["category"],
    },
    empty: {
        requestsMetadata: EmptyRequestBuilderRequestsMetadata,
    },
    reorder: {
        requestsMetadata: ReorderRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CategoriesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CategoriesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListCategoriesResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: CategoriesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateCategoryResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCategoryRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
